import { ZHContent } from '../../protocol/ZH/privacy';
import { serviceData } from '../../protocol/ZH/service';
import common from '@/langue/zh/common' 
import home from '@/langue/zh/home'
import connect from '@/langue/zh/connect'
import apply from '@/langue/zh/apply'
import applyInfo from '@/langue/zh/applyInfo'
import company from '@/langue/zh/company'
import EPD from '@/langue/zh/EPD'
import feedback from '@/langue/zh/feedback'
import footer from '@/langue/zh/footer'
import GPI from '@/langue/zh/GPI'
import LCA from '@/langue/zh/LCA'
import login from '@/langue/zh/login'
import myportal from '@/langue/zh/myportal'
import nav from '@/langue/zh/nav'
import news from '@/langue/zh/news'
import notice from '@/langue/zh/notice'
import PCR from '@/langue/zh/PCR'
import portal from '@/langue/zh/portal'
import protocol from '@/langue/zh/protocol'
import resource from '@/langue/zh/resource'
import seach from '@/langue/zh/seach'
import service from '@/langue/zh/service'
import sigin from '@/langue/zh/sigin'
import user from '@/langue/zh/user'
import about from '@/langue/zh/about'
import taskInfo from '@/langue/zh/taskInfo'
import reportInfo from '@/langue/zh/reportInfo'
import password from '@/langue/zh/password'
console.log(notice,'notice')
export default {
		common,
		login,
		nav,
		footer,
		home,
		news,
		notice,
		resource,
		connect,
		apply,
		applyInfo,
		service,
		company,
		EPD,
		GPI,
		LCA,
		PCR,
		feedback,
		myportal,
		portal,
		protocol,
		seach,
		sigin,
		user,
		about,
		taskInfo,
		reportInfo,
		password
}
